import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_15DRed_14BBlue = () => <CrossRoad coords="2226.000000, 1141.000000"/>;

export default CrossRoad_15DRed_14BBlue;
